<script>
export default {
  mounted: function () {
    window.localStorage.clear();
    window.location.href = '/login';
  }
}
</script>
<style>
body {
  background: inherit;
}
</style>
